/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './fieldDetail.module.scss';
import ChecklistRow from './ChecklistRow';
import { checkChecklistCondition } from '../../InspectionUtils';

const FieldDetail = ({
  full,
  fields,
  maintenance_workorders,
  airfield_workorders,
  selected,
  InspStartDate,
  InspCreatedDate,
  columnDetails,
  answers,
  remarks,
  workorders,
  checklistAttachments,
  toleranceInspection,
  toleranceResult,
  notams,
  connected_actions,
  answerDetails
}) => (
  <table className={styles.detail}>
    <thead
      className={
        workorders && workorders.length ? styles.header : styles.header1
      }
    >
      <tr className={styles.row}>
        {full && (
          <FormattedMessage
            tagName="th"
            id="inspections.answer_details.inspection_checklist"
            defaultMessage="Inspection Checklist"
          />
        )}
        <FormattedMessage
          tagName="th"
          id="inspections.answer_details.conditions"
          defaultMessage="Conditions"
        />
        {toleranceInspection && (
          <>
            <FormattedMessage
              tagName="th"
              id="inspections.answer_details.standard"
              defaultMessage="Standard"
            />
            <FormattedMessage
              tagName="th"
              id="inspections.answer_details.tolerance"
              defaultMessage="Tolerance"
            />
          </>
        )}
        {columnDetails && columnDetails.length ? (
          columnDetails.map(f => (
            <FormattedMessage
              tagName="th"
              id="inspections.answer_details"
              defaultMessage={f.value}
            />
          ))
        ) : (
          <FormattedMessage
            tagName="th"
            id="inspections.answer_details.status"
            defaultMessage="Status"
          />
        )}
        {(workorders?.length > 0 || maintenance_workorders?.length > 0 || airfield_workorders?.length > 0 || connected_actions?.length > 0) ? (
          <FormattedMessage
            tagName="th"
            id="inspections.answer_details.discrepancy"
            defaultMessage="Discrepancy"
          />
        ) : (
          <th />
        )}
        {(notams?.length || workorders?.length) ? (
          <FormattedMessage
            tagName="th"
            id="inspections.answer_details.notams"
            defaultMessage="Notams"
          />
        ) : (
          <th />
        )}
      </tr>
    </thead>
    <tbody className={styles.body}>
      {Object.keys(fields).map((f) => {
        if (f === selected || full) {
          return fields[f].checklist.map(
            (item, i) => checkChecklistCondition(item, answers) && (
                  <ChecklistRow
                    key={item.key}
                    toleranceInspection={toleranceInspection}
                    toleranceResult={toleranceResult?.[fields[f].id]}
                    field={fields[f]}
                    InspCreatedDate={InspCreatedDate}
                    item={item}
                    isColumn={
                    columnDetails !== undefined && columnDetails.length > 0
                  }
                    answer={answers[fields[f].id]}
                    remarks={remarks?.filter(rem => (
                      rem?.field_reference === fields[f].id && rem?.item_reference === item.key
                    ))}
                    workorders={workorders || []}
                    InspStartDate={InspStartDate}
                    maintenanceWorkorders={maintenance_workorders || []}
                    airfield_workorders={airfield_workorders || []}
                    rowSpan={(full && i === 0) ? (fields[f].checklist.filter(itemKey => (
                      checkChecklistCondition(itemKey, answers)
                    )).length) : undefined}
                    notams={notams}
                    checklistAttachments={checklistAttachments}
                    connected_actions={connected_actions}
                    answerDetails={answerDetails}
                  />
            )
          );
        }
        return null;
      })}
    </tbody>
  </table>
);
FieldDetail.propTypes = {
  fields: PropTypes.shape({}).isRequired,
  selected: PropTypes.string.isRequired,
  full: PropTypes.bool,
  answers: PropTypes.shape({}).isRequired,
  remarks: PropTypes.shape({}).isRequired,
  exportInspection: PropTypes.func.isRequired,
  inspectionid: PropTypes.shape({}).isRequired,
  exportInspectionData: PropTypes.func.isRequired,
  answerId: PropTypes.string.isRequired
};

FieldDetail.defaultProps = {
  full: false
};

export default FieldDetail;
